import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { MesaiSiparisi } from './MesaiKaydiService';

/**
 * Atanacak Mesailer (Kargo Modülü > Nakliye, QR Mesai Faz 1b, 11.10.2026).
 * Bütün Lojistik ek mesai havuza düşer; yetkili Müşteri · Bölüm · PO seçip saatleri bölerek siparişe çevirir.
 */

export interface BekleyenMesai {
    mesaiKaydiId: string
    /** "yyyy-MM-dd" */
    tarih: string
    kisiAdi: string
    noktaAdi: string | null
    girisSaati: string
    cikisSaati: string | null
    ekDk: number
    siparisDk: number
    durum: 'BEKLIYOR' | 'YENIDEN'
}

export interface AtananMesaiSatiri {
    companyPoId: string
    etiket: string
    dakika: number
}

export interface AtananMesai {
    mesaiKaydiId: string
    tarih: string
    kisiAdi: string
    noktaAdi: string | null
    satirlar: AtananMesaiSatiri[] | null
    atayan: string | null
    atamaZamani: string | null
    siparisler: MesaiSiparisi[] | null
}

export interface AtaIstegi {
    mesaiKaydiId: string
    /** Toplam = siparisDk; her satır 15 dakikanın katı. */
    satirlar: { companyPoId: string, dakika: number }[]
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - MesaiAtama/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/MesaiAtama/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class MesaiAtamaService {
    static bekleyenler = () => cagir<BekleyenMesai[]>('Bekleyenler');
    static atananlar = (baslangic: string, bitis: string) => cagir<AtananMesai[]>('Atananlar', { baslangic, bitis });
    static ata = (istek: AtaIstegi) => cagir<MesaiSiparisi[]>('Ata', istek);
    static geriAl = (mesaiKaydiId: string) => cagir<boolean>('GeriAl', { mesaiKaydiId });
}
